// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const kangaskhan_mega: PokeData = {
  "id": 10039,
  "name": "kangaskhan-mega",
  "height": 22,
  "weight": 1000,
  "base_experience": 207,
  "types": [
    PokeType.NORMAL
  ],
  "api_moves": [
    "comet-punch",
    "mega-punch",
    "tail-whip",
    "leer",
    "bite",
    "rage",
    "dizzy-punch",
    "reversal",
    "outrage",
    "endure",
    "crunch",
    "fake-out",
    "sucker-punch",
    "double-hit",
    "chip-away"
  ],
  "moves": [
    "leer",
    "bite",
    "outrage",
    "crunch",
    "refresh",
    "protect",
    "tri-attack",
    "growl",
    "purification",
    "headbutt",
    "quick-attack",
    "body-slam",
    "supersonic"
  ],
  "evolution_chain": {
    "id": 53,
    "item": null,
    "species": [
      {
        "name": "kangaskhan",
        "order": 131,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 125,
    "speed": 122,
    "ability_power": 153
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": true,
  "is_gmax": false,
  "regional_variant": null
} as const;
